import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidMessageIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.7 10.7c-.3-.6-.8-1-1.3-1.3l-14-7c-1.5-.7-3.3-.1-4 1.3-.5.8-.5 1.7-.1 2.5L4.4 11h9.1c.6 0 1 .4 1 1s-.4 1-1 1H4.4l-2.1 4.8c-.7 1.5 0 3.3 1.5 4 .4.1.8.2 1.2.2.5 0 .9-.1 1.3-.3l14-7c1.5-.8 2.1-2.6 1.4-4Z"/>
  </SvgIcon>
}

export default SolidMessageIcon
